import React from 'react';
import PropTypes from 'prop-types';
import { useIntegrations } from './hooks';
import styled from 'styled-components';
import Header from '../Header';
import Footer from '../Footer';

const Wrapper = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "header"
    "main"
    "footer"
  ;

  --header-height: 60px;
  @media (min-width: 768px) {
    --header-height: 95px;
  }

  --page-top-offset: calc(var(--header-height) + 15px);
`;

const Main = styled.main`
  height: 100%;
  grid-area: main;
`;

export function AppLayout ({ children }) {
  useIntegrations();
  return (
    <Wrapper>
      <Header className="d-flex" />

      <Main id="main">
        {children}
      </Main>

      <Footer />
    </Wrapper>
  );
}

AppLayout.propTypes = {
  children: PropTypes.node
};

export default AppLayout;
